import {RoleList} from "./RoleList";
import {RoleEdit} from "./RoleEdit";
import {RoleCreate} from "./RoleCreate";

export default {
    list: RoleList,
};